// extracted by mini-css-extract-plugin
module.exports = {"banner":"style-module__banner___3fLYk","warning":"style-module__warning___y_-bQ"};